import { useEffect, useState } from "react";
import { getAccessToken } from "../api/client";
import { canjearPaseAppWeb } from "../api/auth";

/**
 * PASE DE LA APP A LA WEB — la app del organizador abre la consola acá.
 *
 * La app (ya logueada) pide un pase de un solo uso al backend y abre
 * `/entrar-app#c=<pase>&n=<destino>`: el pase viaja en el HASH (nunca llega a
 * un server ni a sus logs, igual que el token de /ver-como), se canjea por una
 * sesión propia de la web y se recarga entero al destino — con el reload,
 * AuthContext nace ya logueado, sin estados a medio camino.
 *
 * Si el pase venció (duran un minuto) o ya se usó: con una sesión previa en
 * este navegador se sigue igual al destino; sin sesión, al login de siempre.
 * El destino sólo puede ser una ruta interna (nada de redirigir afuera).
 */
export function EntrarAppEntrada() {
  const [estado, setEstado] = useState<"entrando" | "fallo">("entrando");

  useEffect(() => {
    const hash = new URLSearchParams(window.location.hash.slice(1));
    const code = hash.get("c");
    const pedido = hash.get("n") ?? "/fotos";
    const destino = pedido.startsWith("/") && !pedido.startsWith("//") ? pedido : "/fotos";
    if (!code) {
      window.location.replace(destino);
      return;
    }
    canjearPaseAppWeb(code)
      .then(() => window.location.replace(destino))
      .catch(() => {
        if (getAccessToken()) {
          // El pase no sirvió pero este navegador ya tenía sesión: adelante.
          window.location.replace(destino);
        } else {
          setEstado("fallo");
          window.setTimeout(() => window.location.replace("/login"), 1800);
        }
      });
  }, []);

  return (
    <div
      style={{
        minHeight: "100dvh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#071426",
        color: "#f1f5f9",
        fontSize: "15px",
        fontWeight: 600,
        padding: "0 24px",
        textAlign: "center",
      }}
    >
      {estado === "entrando"
        ? "Entrando con tu cuenta de la app…"
        : "El pase venció. Te llevamos a la pantalla de ingreso."}
    </div>
  );
}
